import { render, staticRenderFns } from "./MsPopup.vue?vue&type=template&id=0aeca692&scoped=true"
import script from "./MsPopup.vue?vue&type=script&lang=js"
export * from "./MsPopup.vue?vue&type=script&lang=js"
import style0 from "./MsPopup.vue?vue&type=style&index=0&id=0aeca692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeca692",
  null
  
)

export default component.exports